// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cbs-breadcrumb[data-v-0a82830e]{padding:16px 0;font-size:14px}.cbs-breadcrumb .link[data-v-0a82830e]{color:#222;text-decoration:none}.cbs-breadcrumb .link[data-v-0a82830e]:hover{color:#2468f2}.cbs-breadcrumb .text[data-v-0a82830e]{color:#222;opacity:.7}.cbs-breadcrumb .separator[data-v-0a82830e]{margin:0 8px}", ""]);
// Exports
module.exports = exports;
